<template>
  <!-- Page Content -->
  <div id='page-wrapper'>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid'>
      <div class='row'>
        <div class='col-lg-12'>
          <h1 class='page-header'>كشف المرتبات</h1>
        </div>
        <!-- /.col-lg-12 -->
      </div>
      <!-- /.row -->
      <div class='row'>
        <div class='col-lg-12'>
          <div class='panel panel-default'>
            <div class='panel-heading'>
              هنا يتم عرض كشف المرتبات
            </div>
            <div class='alert alert-danger alert-dismissable' v-if='geterrorShow'>
              عفوا لا يمكن عرض رواتب تاريخ مستقبلى
            </div>
            <div class='form-group col-lg-3 col-sm-3'>
              <h4 >الفرع:</h4>
              <select class="form-control" v-model="filterBranche" style="padding:0px">
                <option v-for="item in branches" :key="item.id" v-bind:value="item.id">
                  {{ item.name }}
                </option>
              </select>
            </div>
            <div class='form-group col-lg-3 col-sm-3'>
              <h4 >الوظيفة:</h4>
              <select class="form-control" v-model="jobID" style="padding:0px">
                <option v-for="item in salary_show" :key="item.id" v-bind:value="item.id">
                  {{ item.name }}
                </option>
              </select>
            </div>
            <div class='form-group col-lg-3 col-sm-3'>
              <h4 >الشهر:</h4>
              <div class='form-group col-lg-6 col-sm-6' style="padding:0px">
              <select class="form-control" v-model="xMonth" style="padding:0px">
                <option v-for="item in 12" :key="item" v-bind:value="item">
                  {{ item }}
                </option>
              </select>
              </div>
              <div class='form-group col-lg-6 col-sm-6' style="padding:0px">
              <select class="form-control" v-model="xYear" style="padding:0px">
                <option v-for="item in 20" :key="item" v-bind:value="item">
                  {{ item + 2021 }}
                </option>
              </select>
            </div>
            </div>
            <div class='form-group col-lg-3 col-sm-3'>
              <h4 >&nbsp;</h4>
              <button @click='GetData' type='button' class='btn btn-primary btn-block'>عرض</button>
            </div>
            <!-- /.panel-heading -->
            <div class='panel-body'>
              <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                <thead>
                  <tr>
                    <th style='text-align: center'>م</th>
                    <th style='text-align: center'>الموظف</th>
                    <th style='text-align: center'>الراتب</th>
                    <th style='text-align: center'>الخصومات</th>
                    <th style='text-align: center'>الحوافز</th>
                    <th style='text-align: center'>السلفيات</th>
                    <th style='text-align: center'>تاريخ الصرف</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class='odd gradeX' v-for='(record,index) in records' :key='record.id'>
                    <td align='center'>{{index+1}}</td>
                    <td align='right'>{{record.name}}</td>
                    <td align='center'>{{record.salary}}</td>
                    <td align='center'>{{record.discount}}</td>
                    <td align='center'>{{record.Incentive}}</td>
                    <td align='center'>{{record.advances}}</td>
                    <td v-show='record.pay_date' align='center'>{{record.pay_date}}</td>
                    <td v-show='!record.pay_date' align='center'>
                      <button v-show="$per.value.savePayroll" @click='getDetails(record.user_id)' type='button' class='btn btn-outline btn-info btn-xs' data-toggle='modal' data-target='#detailsModal'>تفاصيل</button>
                      <button v-show="$per.value.savePayroll" @click='showForm(record)' type='button' class='btn btn-outline btn-info btn-xs' data-toggle='modal' data-target='#myModal'>صرف</button>
                      <button v-show="$per.value.savePayroll" @click='getSheet(record)' type='button' class='btn btn-outline btn-info btn-xs' data-toggle='modal' data-target='#empPayroll'>كشف</button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- /.table-responsive -->
            </div>
            <!-- /.panel-body -->
          </div>
          <!-- /.panel -->
        </div>
        <!-- /.col-lg-12 -->
      </div>
    </div>
    <!-- Modal -->
    <div class='modal fade' id='myModal' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
      <div class='modal-dialog  modal-xs'>
        <div class='modal-content'>
          <div class='modal-header'>
            <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
            <h4 class='modal-title' id='myModalLabel'>{{title}}</h4>
          </div>
          <form role='form'>
            <div class='modal-body'>
              <div class='alert alert-danger alert-dismissable' v-if='errorShow'>
                <ul v-if='validationErrors'>
                  <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                </ul>
              </div>
              <div class='alert alert-success alert-dismissable' v-if='successShow'>
                {{success}}
              </div>
              <fieldset>
                <div class='form-group col-lg-6 col-sm-6'>
                  <span>تاريخ الصرف:</span>
                  <Datepicker :typeable="true" :format="customFullFormatter" :language="ar" :bootstrap-styling="true" v-model='record.pay_date'></Datepicker>
                </div>
                <div class='form-group  col-lg-6 col-sm-6' style='padding: 10px 0px 0px 10px;'>
                  <span>الخزنة:</span>
                  <select class="form-control" style="padding: 0px" v-model="record.treasury_id">
                    <option v-for="treasury in treasuries" v-bind:key="treasury.id" v-bind:value="treasury.id">
                      {{ treasury.name }}
                    </option>
                  </select>
                </div>
              </fieldset>
            </div>
            <div class='modal-footer'>
              <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
              <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
              <button @click='saveData' type='button' class='btn btn-primary'>صرف</button>
            </div>
          </form>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
    <!-- Emp Payroll Modal -->
    <div class='modal fade' id='empPayroll' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
      <div class='modal-dialog  modal-lg'>
        <div class='modal-content'>
          <div class='modal-header'>
            <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
            <h4 class='modal-title' id='myModalLabel'>{{title}}</h4>
          </div>
          <form role='form'>
            <div class='modal-body'>
              <div class='alert alert-danger alert-dismissable' v-if='errorShow'>
                <ul v-if='validationErrors'>
                  <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                </ul>
              </div>
              <div class='alert alert-success alert-dismissable' v-if='successShow'>
                {{success}}
              </div>
              <fieldset>
                <div id="contentToPrint">
                <div class='form-group col-lg-12'>
                <table width='100%' class='table  table-bordered ' >
                  <thead>
                    <tr>
                      <th style='text-align: center'><h3> كشف مرتبات شهر {{xMonth}} سنة {{xYear + 2021}}</h3></th>
                    </tr>
                  </thead>
                </table>
                </div>
                <div class='form-group col-lg-6 col-sm-6'>
                  <span>الاسم:</span>
                  {{empName}}                                 </div>
                  <div class='form-group  col-lg-6 col-sm-6' style='padding: 10px 0px 0px 10px;'>
                    <span>الوظيفة:</span>
                    {{empJob}}
                  </div>
                  <div v-if="returnType === 1 || returnType === 3">

                    <div class='form-group col-lg-6 col-sm-6'>
                      <table width='100%' class='table  table-bordered ' >
                        <thead>
                          <tr>
                            <th colspan=4 style='vertical-align: middle;padding:2px;text-align: center'>الاستحقاقات</th>
                          </tr>
                          <tr>
                            <th style='padding:5px;text-align: center'>العدد</th>
                            <th style='padding:5px;text-align: center'>العمولة</th>
                            <th style='padding:5px;text-align: center'>الاجمالى</th>
                            <th style='padding:5px;text-align: center'>بيان</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr class='odd gradeX' v-for='(item) in dues' :key='item.index' >
                            <td align='right'>{{item.count}}</td>
                            <td align='right'>{{item.fee}}</td>
                            <td align='right'>{{item.total}}</td>
                            <td align='right'>{{item.type}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class='form-group col-lg-6 col-sm-6'>
                      <table width='100%' class='table  table-bordered ' >
                        <thead>
                          <tr>
                            <th colspan=2 style='vertical-align: middle;padding:2px;text-align: center'>الاستقطاعات</th>
                          </tr>
                          <tr>
                            <th style='padding:5px;text-align: center'>المبلغ</th>
                            <th style='padding:5px;text-align: center'>بيان</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr class='odd gradeX' v-for='(item) in deductions' :key='item.index' >
                            <td align='right'>{{item.amount}}</td>
                            <td align='right'>{{item.type}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div v-if="returnType === 2">

                    <div class='form-group col-lg-8 col-sm-8'>
                      <table width='100%' class='table  table-bordered ' >
                        <thead>
                          <tr>
                            <th rowspan=2 style='vertical-align: middle;padding:2px;text-align: center'>البيان</th>
                            <th colspan=2 style='vertical-align: middle;padding:2px;text-align: center'>كاش</th>
                            <th colspan=2 style='vertical-align: middle;padding:2px;text-align: center'>قسط</th>
                            <th rowspan=2 style='vertical-align: middle;padding:2px;text-align: center'>الاجمالى</th>
    </tr>
                          <tr>
                            <th style='padding:2px;text-align: center'>العدد</th>
                            <th style='padding:2px;text-align: center'>العمولة</th>
                            <th style='padding:2px;text-align: center'>العدد</th>
                            <th style='padding:2px;text-align: center'>العمولة</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr  v-for='record in dues' :key='record.id' >
                            <td style="padding:2px" align='right'>{{record.offer_name}}</td>
                            <td style="padding:2px" align='center'>{{record.cash}}</td>
                            <td style="padding:2px" align='center'>{{record.cash_commission}}</td>
                            <td style="padding:2px" align='center'>{{record.premium}}</td>
                            <td style="padding:2px" align='center'>{{record.premium_commission}}</td>
                            <td style="padding:2px" align='center'>{{record.total}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class='form-group col-lg-4 col-sm-4'>
                      <table width='100%' class='table  table-bordered ' >
                        <thead>
                          <tr>
                            <th colspan=2 style='vertical-align: middle;padding:2px;text-align: center'>الاستقطاعات</th>
                          </tr>
                          <tr>
                            <th style='padding:5px;text-align: center'>المبلغ</th>
                            <th style='padding:5px;text-align: center'>بيان</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr class='odd gradeX' v-for='(item) in deductions' :key='item.index' >
                            <td align='right'>{{item.amount}}</td>
                            <td align='right'>{{item.type}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                    <div class='form-group col-lg-12'>
                      <table width='100%' class='table  table-bordered ' >
                        <thead>
                          <tr>
                            <th style='text-align: center'>إجمالى الاستحقاقات</th>
                            <th style='text-align: center'>إجمالى الاستقطاعات</th>
                            <th style='text-align: center'>الصافى</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td style="padding:5px" align='center'><h3>{{totalDues}}</h3></td>
                            <td style="padding:5px" align='center'><h3>{{totalDeductions}}</h3></td>
                            <td style="padding:5px" align='center'><h3>{{netSalary}}</h3></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class='form-group col-lg-12'>
                      <table width='100%' class='table  table-bordered ' >
                        <thead>
                          <tr>
                            <th style='text-align: center'><h4>{{salaryStr}}</h4></th>
                          </tr>
                        </thead>
                      </table>
                    </div>
                  </div>
                  </fieldset>
                </div>
                <div class='modal-footer'>
                  <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
                  <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
                  <button @click='saveData' type='button' class='btn btn-primary'>صرف</button>
                  <button v-simple-print="'contentToPrint'"  type='button' class='btn btn-primary'>طباعة</button>
                </div>
              </form>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </div>
        <!-- Emp Payroll Modal -->
        <!-- Modal Details -->
        <div class='modal fade' id='detailsModal' tabindex='-1' role='dialog'  aria-labelledby='تفاصيل عمليات الموظف' aria-hidden='true'>
          <div class='modal-dialog  modal-lg'>
            <div class='modal-content'>
              <div class='modal-header'>
                <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
                <h4 class='modal-title' id='myModalLabel'>{{title}}</h4>
              </div>
                <div class='modal-body'>
                  <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                      <thead>
                        <tr>
                          <th style='text-align: center'>م</th>
                          <th style='text-align: center'>الكود</th>
                            <th style='text-align: center'>الاسم</th>
                            <th v-if="jobID === 1" style='text-align: center'>العقد</th>
                            <th v-if="jobID === 2" style='text-align: center'>العملية</th>
                            <th style='text-align: center'>التاريخ</th>
                            <th style='text-align: center'>النوع</th>
                            <th v-if="jobID !== 3" style='text-align: center'>المقدم</th>
                            <th v-if="jobID === 3" style='text-align: center'>المفوض</th>
                            <th v-if="jobID === 3" style='text-align: center'>الفنى</th>
                        </tr>
                      </thead>
                      <tbody>
                          <tr class='odd gradeX' v-for='(record, index) in recordgDetails' :key='record.id'>
                            <td align='center'>{{index + 1}}</td>
                            <td align='center'>{{record.rec_id}}</td>
                            <td align='center'>{{record.name}}</td>
                            <td v-if="jobID === 1" align='center'>{{record.contract_id}}</td>
                            <td v-if="jobID === 2" align='center'>{{record.offer_name}}</td>
                            <td align='center'>{{record.date}}</td>
                            <td align='center'>{{record.type}}</td>
                            <td v-if="jobID !== 3" align='center'>{{record.paid}}</td>
                            <td v-if="jobID === 3" align='center'>{{record.dele}}</td>
                            <td v-if="jobID === 3" align='center'>{{record.tec}}</td>
                          </tr>
                      </tbody>
                  </table>
                  <table v-if="jobID === 1" width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                      <thead>
                        <tr>
                          <th style='text-align: center'>م</th>
                          <th style='text-align: center'>الكود</th>
                            <th style='text-align: center'>الاسم</th>
                            <th style='text-align: center'>العملية</th>
                            <th style='text-align: center'>التاريخ</th>
                            <th style='text-align: center'>النوع</th>
                            <th style='text-align: center'>الحالة</th>
                        </tr>
                      </thead>
                      <tbody>
                          <tr class='odd gradeX' v-for='(record, index) in recordgDetails1' :key='record.id'>
                            <td align='center'>{{index + 1}}</td>
                            <td align='center'>{{record.rec_id}}</td>
                            <td align='center'>{{record.name}}</td>
                            <td align='center'>{{record.offer_name}}</td>
                            <td align='center'>{{record.date}}</td>
                            <td align='center'>{{record.type}}</td>
                            <td align='center'>{{record.exeu}}</td>
                          </tr>
                      </tbody>
                  </table>
                </div>
                <div class='modal-footer'>
                  <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
                </div>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </div>
        <!-- /.modal Details-->
        <!-- /.container-fluid -->
      </div>
    </template>
<script>
import axios from 'axios'
import Datepicker from 'vuejs-datepicker'
import tafqeet from '@/./assets/Tafqeet.js'
import {ar} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
export default {
  components: {
    Datepicker
  },
  name: 'payroll',
  data () {
    return {
      xYear: 0,
      xMonth: 0,
      salary_show: [{id: 1, name: 'فنى'}, {id: 2, name: 'مبيعات'}, {id: 3, name: 'مفوض'}],
      jobID: 1,
      salaryStr: '',
      empName: '',
      empJob: '',
      totalDeductions: 0,
      totalDues: 0,
      netSalary: 0,
      deductions: {},
      recordgDetails: '',
      recordgDetails1: '',
      returnType: '',
      dues: {},
      ar: ar,
      validationErrors: '',
      records: {},
      record: {},
      branches: [],
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      isLoadingDelete: false,
      treasuries: [],
      geterrorShow: false,
      filterBranche: '',
      filterMonth: '',
      title: ''
    }
  },
  created () {
    this.filterBranche = localStorage.getItem('BrancheID')
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    let i = this.branches.findIndex(x => x.id === parseInt(this.filterBranche))
    if (i > -1) {
      this.treasuries = this.branches[i].treasuries
    }
    this.filterMonth = new Date()
  },
  methods: {
    customFormatter (date) {
      return moment(date).format('YYYY-MM')
    },
    customFullFormatter (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    GetData () {
      this.geterrorShow = false
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getPayroll', {
        token: localStorage.getItem('token'),
        date: (this.xYear + 2021) + '-' + this.xMonth + '-01',
        branche: this.filterBranche,
        jobID: this.jobID
      })
        .then(({data}) => {
          this.records = data
          this.isLoadingData = false
        })
        .catch(err => {
          this.records = {}
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.error === 'invalid date') {
            this.geterrorShow = true
          }
          this.isLoadingData = false
        })
    },
    // =========================================================
    getSheet (rec) {
      this.returnType = ''
      var dateObj = new Date((this.xYear + 2021) + '-' + this.xMonth + '-01')
      var lastDay = ((new Date(dateObj.getFullYear(), dateObj.getMonth() + 1, 0)).getDate())
      // ------------------------------------------------
      this.geterrorShow = false
      this.isLoadingData = true
      axios.post(this.$apiURL + 'get-emp-payroll', {
        token: localStorage.getItem('token'),
        type: rec.type,
        from: (this.xYear + 2021) + '-' + this.xMonth + '-01',
        to: (this.xYear + 2021) + '-' + this.xMonth + '-' + lastDay,
        id: rec.user_id
      })
        .then(res => {
          this.totalDeductions = 0
          this.totalDues = 0
          this.netSalary = 0
          this.deductions = res.data.deductions
          this.dues = res.data.dues
          this.returnType = res.data.data.type
          this.isLoadingData = false
          this.empName = res.data.data.name
          this.empJob = res.data.data.job
          for (let i in this.deductions) { this.totalDeductions += parseInt(this.deductions[i].amount) }
          for (let i in this.dues) { this.totalDues += parseInt(this.dues[i].total) }
          this.netSalary = (parseInt(this.totalDues) || 0) - (parseInt(this.totalDeductions) || 0)
          this.salaryStr = 'فقط ' + tafqeet(this.netSalary) + ' جنيها لا غير '
        })
        .catch(err => {
          this.records = {}
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.error === 'invalid date') {
            this.geterrorShow = true
          }
          this.isLoadingData = false
        })
    },
    // =========================================================
    showForm (recID) {
      this.errorShow = false
      this.successShow = false
      this.error = ''
      this.title = 'صرف الراتب'
      this.record = {'id': recID.id, 'emp_id': recID.emp_id, 'month': recID.month, 'pay_date': recID.pay_date, 'treasury_id': recID.treasury_id}
    },
    // =========================================================
    getDetails (id) {
      this.recordgDetails = ''
      this.recordgDetails1 = ''
      this.type = ''
      this.isLoadingData = true
      axios.post(this.$apiURL + 'get-emp-payroll-details', {
        token: localStorage.getItem('token'),
        date: (this.xYear + 2021) + '-' + this.xMonth + '-01',
        id: id
      })
        .then(({ data }) => {
          this.recordgDetails = data.rec
          this.recordgDetails1 = data.rec1
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    // =========================================================
    saveData () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'savePayroll', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        pay_date: this.record.pay_date,
        treasury_id: this.record.treasury_id
      })
        .then(res => {
          this.isLoadingSave = false
          let i = this.records.map(record => record.id).indexOf(this.record.id)
          this.records.splice(i, 1, res.data)
          this.success = 'تم الحفظ بنجاح'
          this.successShow = true
          this.errorShow = false
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/employees/Payroll.vue